module.exports = __webpack_public_path__ + "static/media/install7.1c89711d.png";